export enum FiatCurrency {
  ArgentinePeso = 'ARS',
  AustralianDollar = 'AUD',
  BrazilianReal = 'BRL',
  CanadianDollar = 'CAD',
  ChineseYuan = 'CNY',
  ColombianPeso = 'COP',
  Euro = 'EUR',
  BritishPound = 'GBP',
  HongKongDollar = 'HKD',
  IndonesianRupiah = 'IDR',
  IndianRupee = 'INR',
  JapaneseYen = 'JPY',
  MexicanPeso = 'MXN',
  NigerianNaira = 'NGN',
  PakistaniRupee = 'PKR',
  RussianRuble = 'RUB',
  SingaporeDollar = 'SGD',
  SouthKoreanWon = 'KRW',
  ThaiBaht = 'THB',
  TurkishLira = 'TRY',
  UkrainianHryvnia = 'UAH',
  UnitedStatesDollar = 'USD',
  VietnameseDong = 'VND',
}

export const DEFAULT_LOCAL_CURRENCY: FiatCurrency = FiatCurrency.UnitedStatesDollar

export const ORDERED_CURRENCIES: FiatCurrency[] = [
  FiatCurrency.UnitedStatesDollar,
  FiatCurrency.ArgentinePeso,
  FiatCurrency.AustralianDollar,
  FiatCurrency.BrazilianReal,
  FiatCurrency.CanadianDollar,
  FiatCurrency.ChineseYuan,
  FiatCurrency.ColombianPeso,
  FiatCurrency.Euro,
  FiatCurrency.BritishPound,
  FiatCurrency.HongKongDollar,
  FiatCurrency.IndonesianRupiah,
  FiatCurrency.IndianRupee,
  FiatCurrency.JapaneseYen,
  FiatCurrency.SouthKoreanWon,
  FiatCurrency.MexicanPeso,
  FiatCurrency.NigerianNaira,
  FiatCurrency.PakistaniRupee,
  FiatCurrency.RussianRuble,
  FiatCurrency.SingaporeDollar,
  FiatCurrency.ThaiBaht,
  FiatCurrency.TurkishLira,
  FiatCurrency.UkrainianHryvnia,
  FiatCurrency.VietnameseDong,
]
